module.exports = __webpack_public_path__ + "img/photo_250020784_1.c0c8c146.jpg";